const webvars = window.webvars || {}

const isProdEnv = webvars.IS_PROD_ENV || false

export const isDev = !isProdEnv
